<template>
	<NotificationTemplate class="notification-container" v-bind="notificationProps" v-on="$listeners">
		<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
			<slot :name="slot" v-bind="scope" />
		</template>
		<template #archive>
			<AppLoader v-if="isLoading" />
			<AppTooltip v-else :text="tooltipText">
				<SIcon name="archive-x-notification" :height="14" :width="16" />
			</AppTooltip>
		</template>
	</NotificationTemplate>
</template>
<script>
export default {
	name: 'Notification',
	props: {
		titleArr: { type: Array },
		isLoading: { type: Boolean },
		takeActionTitle: { type: String },
		allowReTakeAction: { type: Boolean },
		notification: { type: Object, required: true },
		allowArchive: { type: Boolean, default: true },
		verticalPadding: { type: [String, Number], default: 15 },
		horizontalPadding: { type: [String, Number], default: 20 },
	},
	computed: {
		notificationProps() {
			return {
				status: this.status,
				iconUrl: this.iconUrl,
				subtitle: this.subtitle,
				createdAt: this.createdAt,
				isArchived: this.isArchived,
				allowArchive: this.allowArchive,
				isCustomImage: this.isCustomImage,
				verticalPadding: this.verticalPadding,
				horizontalPadding: this.horizontalPadding,
				takeActionTitle: this.takeActionTitleText,
				allowReTakeAction: this.allowReTakeAction,
				titleArr: this.titleArr || [{ text: this.title }],
			};
		},
		tooltipText() {
			return this.isArchived ? 'Unarchive' : 'Archive';
		},
		iconUrl() {
			return this.notification.metadata.icon_url;
		},
		status() {
			return this.notification.status;
		},
		createdAt() {
			return this.notification.created_at;
		},
		title() {
			return this.notification.metadata.title;
		},
		subtitle() {
			return this.notification.metadata.subtitle;
		},
		isArchived() {
			return this.notification.archived;
		},
		isCustomImage() {
			return false;
		},
		takeActionTitleText() {
			return this.takeActionTitle || this.notification?.metadata?.action_title || 'Take action';
		},
	},
};
</script>
<style lang="scss" scoped>
.notification-container {
	overflow: hidden;
}
</style>
